import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const GRID_LAYER_ID = 'GridLayer';

const gridLineStrokeColor = 'black';

const GridLayer = ({ scale = 1 }) => {
    const [lines, setLines] = useState([]);

    const isGridEnabled = useSelector((state) => state.store.isGridEnabled);

    const storeData = useSelector((state) => state.store.storeData);

    const st = storeData ? storeData.floor_plan : null;

    const stw = st ? st.width || 1 : 1;
    const std = st ? st.depth || 1 : 1;

    const gw = st ? st.grid_width || 100 : 100;
    const gd = st ? st.grid_depth || 100 : 100;

    useEffect(() => {
      if (isGridEnabled) {
        const numRows = std / gd;
        const numCols = stw / gw;

        const lines = [];
        for(let i = 0; i < numRows; i++) {
          lines.push([0, i*gd, stw, i*gd]);
        }
        for(let i = 0; i < numCols; i++) {
          lines.push([i*gw, 0, i*gw, std]);
        }

        setLines(lines);
      } else {
        setLines([]);
      }
    }, [isGridEnabled, gw, gd, stw, std]);

    return (
      <svg
        id={GRID_LAYER_ID}
        opacity={0.1}
        style={{
          position: 'absolute',
          width: stw + 'px',
          height: std + 'px',
        }}
      >
        {isGridEnabled && lines.map((line, index) => {
          const id = line.join('_');
          return (
            <line
              key={id}
              id={`GridLine_${id}`}
              x1={line[0]}
              x2={line[2]}
              y1={line[1]}
              y2={line[3]}
              stroke={gridLineStrokeColor}
              strokeWidth={1 / scale}
            />
          )
        })}
      </svg>
    );
};

export default GridLayer;
